<script setup lang="ts">
import { DropdownMenuSeparator } from 'reka-ui';
</script>

<template>
    <DropdownMenuSeparator class="bg-muval-gray-5 my-1 h-px" />
</template>
